module.exports = __webpack_public_path__ + "static/assets/12574f63044f0a2d1b8f591105c15b8b.svg";